<template>
  <div class="page-content">
    <div class="content">
      <div class="tree-content">
        <div class="search">
          <el-select
            style="width: 100%"
            size="small"
            v-model="companyId"
            placeholder="请选择"
            @change="handleCompanyChange"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="tree-box">
          <el-tree
            class="tree-item"
            ref="tree"
            node-key="measureId"
            :data="treeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
      <div class="right-content">
        <div class="search">
          <el-form :inline="true" :model="filters" :size="size">
            <el-form-item>
              <el-date-picker
                v-model="filters.date"
                type="daterange"
                value-format="yyyy/MM/dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-content">
          <el-table
            :data="tableData"
            height="100%"
            header-cell-class-name="table-header-cell"
            cell-class-name="table-cell"
            border
            stripe
            fit
            highlight-current-row
          >
            <el-table-column
              prop="startTime"
              label="开始时间"
              min-width="120"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="orderName"
              label="工单名称"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="orderType"
              label="类型"
              min-width="60"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ handleTypeFormat(scope.row.orderType) }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="getInfo(scope.$index, scope.row)"
                  type="text"
                  :size="size"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 详情 -->
      <detail-drawer
        ref="detailDrawer"
        v-if="detailDrawerVisible"
        :statusList="statusList"
        :typeList="typeList"
      ></detail-drawer>
    </div>
  </div>
</template>

<script>
import detailDrawer from "../orderTask/detailDrawer.vue";
import tree from "@/utils/tree";
export default {
  components: { detailDrawer },
  data() {
    return {
      size: "small",
      companyId: "",
      companyList: [],
      treeData: [],
      defaultProps: {
        children: "children",
        label: "measureName",
      },
      filters: {
        date: [],
      },
      tableData: [],
      activeId: "",
      detailDrawerVisible: false,
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 },
      ],
      statusList: [
        { label: "待接单", value: 1 },
        { label: "已接单", value: 2 },
        { label: "已出发", value: 3 },
        { label: "已到达", value: 4 },
        { label: "工作中", value: 5 },
        { label: "待审核", value: 6 },
        { label: "已完成", value: 7 },
        { label: "已取消", value: 8 },
        { label: "待分配", value: 9 },
      ],
    };
  },
  created() {
    this.filters.date = [
      this.$moment(new Date())
        .startOf("month")
        .format("YYYY/MM/DD"),
      this.$moment(new Date())
        .endOf("month")
        .format("YYYY/MM/DD"),
    ];
    this.handleGetClients();
  },
  methods: {
    handleGetClients() {
      this.$api.electricOperations
        .listClientsForElectricOperationsCompany(0, "", "")
        .then((res) => {
          if (res.success) {
            this.companyList = res.data;
            this.companyId = this.companyList[0].id;
            this.handleGetMeasureInfo();
          }
        });
    },
    handleGetMeasureInfo() {
      this.$api.electricOperations
        .getMOViewTreeNodes(this.companyId)
        .then((res) => {
          let treeData = [];
          if (res.success) {
            treeData = tree.creatTreeJson2(
              res.data,
              "measureId",
              "parentId",
              0
            );
          }
          this.treeData = treeData;
          if (treeData.length > 0) {
            this.activeId = this.treeData[0].measureId;
            this.$nextTick(() => {
              this.$refs["tree"].setCurrentKey(this.activeId);
            });
            this.handleQuery();
          }
        });
    },
    handleNodeClick(data, node) {
      this.activeId = data.measureId;
      this.handleQuery();
    },
    handleCompanyChange(val) {
      this.companyId = val;
      this.handleGetMeasureInfo();
    },
    handleQuery() {
      let startTime = "";
      let endTime = "";
      if (this.filters.date && this.filters.date.length > 1) {
        startTime = this.filters.date[0];
        endTime = this.filters.date[1];
      }
      this.tableData = [];
      this.$api.electricOperations
        .getEquipmentMaintenanceHistory(this.activeId, startTime, endTime)
        .then((res) => {
          if (res.success) {
            this.tableData = res.data;
          }
        });
    },
    getInfo(index, row) {
      this.$api.electricOperations
        .getElectricOperationsWorkOrder(row.workOrderId)
        .then((res) => {
          if (res.success) {
            this.detailDrawerVisible = true;
            this.$nextTick(() => {
              this.$refs.detailDrawer.init(res.data);
            });
          }
        });
    },
    handleTypeFormat(cellValue) {
      let val = "";
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label;
        }
      });
      return val;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  text-align: left;
  display: flex;
}

.tree-content {
  margin-right: 12px;
  width: 240px;
  height: 100%;

  display: flex;
  flex-flow: column;
  // border: 1px solid #ddd;
  .search {
    margin-bottom: 12px;
  }
  .tree-box {
    flex: 1;
    overflow: hidden;
  }
}

.right-content {
  flex: 1;
  height: 100%;
  // border: 1px solid #ddd;
  .table-content {
    height: calc(100% - 60px);
  }
}

.tree-item ::v-deep .is-current {
  font-weight: bold;
  background: #168bff30;
  background-color: #168bff30;
}
</style>
